document.addEventListener('DOMContentLoaded', function () {
  var sz = 0;
  var timersz = setInterval(function () {
    var bestFitSizeChart = document.querySelector('.best-fit-size-chart');
    var labelWrapper = document.querySelector('.product__label-wrapper');

    if (bestFitSizeChart) {
      if (labelWrapper && labelWrapper.innerHTML.toLowerCase().includes('size')) {
        labelWrapper.appendChild(bestFitSizeChart);
      }
      clearInterval(timersz);
    }

    if (bestFitSizeChart) {
      if (labelWrapper && labelWrapper.innerHTML.includes(' Size ')) {
        labelWrapper.appendChild(bestFitSizeChart);
      }
      clearInterval(timersz);
    }

    if (sz > 200) {
      clearInterval(timersz);
    }

    sz++;
  }, 50);

document.querySelectorAll('.new-read-more').forEach(function(element) {
  element.addEventListener('click', function() {
    document.querySelectorAll('.section-header__subheading').forEach(function(subheading) {
      subheading.classList.add('collapse');
    });
    this.style.display = 'none';
  });
});

});


var ur = window.location.href;
if(ur.includes('')){

  
 (function(document, tag) {
    var scriptTag = document.createElement(tag), // create a script tag
        firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
    scriptTag.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js'; // set the source of the script to your script
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}(document, 'script'));



  
document.addEventListener('DOMContentLoaded', function () {
 
 
   setTimeout(function(){ 


$('div#shown_form input.form-control').change(function(){
  var prop = $(this).attr('name');
   $('#within_form [name="'+ prop +'"]').val($(this).val()); 
}); 
$('div#shown_form  .checkbox input').click(function(){
  $('#within_form  .checkbox input').click()
}); 
   jQuery('.media img').click(function(){
  $('.lighbox__open-button.visible').eq(0).click();
}); 
 jQuery('.read-more').click(function(){
  jQuery('.product__description-content').eq(0).addClass('full-content')
    $(this).hide();
}); 
 jQuery(document).scroll(function() {
    if(jQuery('.quick-purchase-bar.active').length){
      jQuery('body').addClass('show-sticky');
    }
   else{
     jQuery('body').removeClass('show-sticky');
   }
    
}); 



  jQuery('body').append(jQuery(`<div class="simple-popup simple-shipping-popup">
  <div class="popup-content">
    <div class="popup-title">Free Shipping <span class="simple-close">×</span></div>
    <div class="popup-p">
      <div class="popup-contentt">
        Orders over $150 automatically get Free regular shipping. See our <a href=" https://apostl.com.au/pages/terms-conditions">Shipping policy here.</a>
      </div>
    </div>
  </div>
</div>
`))
     jQuery('body').append(jQuery(`<div class="simple-popup simple-free-return-popup">
    <div class="popup-content">
        <div class="popup-title"> Free Returns <span class="simple-close">×</span> </div>
        <div class="popup-p">
            <div class="popup-contentt">Regular-priced jackets are eligible for a <b>full refund within 7 days</b>. Sale items are eligible for <b>exchange or store credit only</b>.  Please see <a href=" https://apostl.com.au/pages/refunds-and-exchanges">our return policy here. </a>
            </div>
        </div>
    </div>
</div>`))
    jQuery('body').append(jQuery(`<div class="simple-popup simple-return-popup"> <div class="popup-content"> <div class="popup-title"> Returns and Exchange <span class="simple-close">×</span> </div><div class="popup-p"> <div class="popup-contentt"> We want you to fall in love with your Apostl pieces, so if you’re not 100% happy with your purchase you can return it for a store credit or a refund within 30 days of purchase. Please see <a href=" https://apostl.com.au/pages/refunds-and-exchanges">our return policy here. </a> </div></div></div></div>`))
    jQuery('body').append(jQuery(`<div class="simple-popup simple-warranty-popup"> <div class="popup-content"> <div class="popup-title"> Warranty <span class="simple-close">×</span> </div><div class="popup-p"> <div class="popup-contentt"> At APOSTL, our handcrafted products showcase the finest quality leather, featuring natural markings that add character. Our 12-month warranty covers manufacturing faults, ensuring your confidence in our craftsmanship. Please note that general wear, markings, and fading are inherent to genuine leather and not considered manufacturing faults. </div></div></div></div>`))
     jQuery('body').append(jQuery(`<div class="simple-popup simple-promise-popup"> <div class="popup-content"> <div class="popup-title"> Custom Fit Guaranteed <span class="simple-close">×</span> </div><div class="popup-p"> <div class="popup-contentt"> Ensuring the utmost satisfaction with your jacket's fit is paramount to us. If, upon receiving your purchased jacket, you discover any sizing discrepancies, such as sleeves that are too long or short, we are pleased to provide a personalized solution through custom measurements. For additional information, please feel free to contact us via email, and our team will be dedicated to accommodating your preferences </div></div></div></div>`))
     jQuery('body').append(jQuery(`<div class="simple-popup simple-made-popup">
    <div class="popup-content">
        <div class="popup-title"> Made to Measure <span class="simple-close">×</span> </div>
        <div class="popup-p">
            <div class="popup-contentt"> 
            <img src="https://cdn.shopify.com/s/files/1/2523/1282/files/How_to_Measure_63aeb83a-50f6-4173-8bcd-4b0d09a856df.jpg?v=1721974225">    
            
            </div>
        </div>
    </div>
</div>`))

     
    
  jQuery('#simple-shipping').click(function(e){
  e.stopPropagation();
  jQuery('.simple-shipping-popup').eq(0).addClass('open')
    jQuery('body').addClass('popupp');
  });   

         jQuery('#simple-free-return').click(function(e){
  e.stopPropagation();
  jQuery('.simple-free-return-popup').eq(0).addClass('open')
          jQuery('body').addClass('popupp');
  });   
  
        jQuery('#simple-return').click(function(e){
  e.stopPropagation();
  jQuery('.simple-return-popup').eq(0).addClass('open')
          jQuery('body').addClass('popupp');
  });   

jQuery('.how-to-measure-popup').click(function(e){
  e.stopPropagation();
  jQuery('.simple-made-popup').eq(0).addClass('open')
          jQuery('body').addClass('popupp');
  });        



        jQuery('#simple-warranty').click(function(e){
  e.stopPropagation();
  jQuery('.simple-warranty-popup').eq(0).addClass('open')
          jQuery('body').addClass('popupp');
  });   

     
        jQuery('#simple-promise').click(function(e){
  e.stopPropagation();
  jQuery('.simple-promise-popup').eq(0).addClass('open')
          jQuery('body').addClass('popupp');
  });   
 jQuery('span.simple-close').click(function(){
  jQuery(this).parent().parent().parent().removeClass('open')
   jQuery('body').removeClass('popupp');
}); 
    
    jQuery('.simple-popup').click(function(event){
  event.stopPropagation();
});
   jQuery(window).click(function() {
     if(jQuery('body > .open').length){
       jQuery('span.simple-close').click();
     }
  
});

 }, 1000); 
})
}


var ur = window.location.href;
if(ur.includes('/collection')){
   (function(document, tag) {
    var scriptTag = document.createElement(tag), // create a script tag
        firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
    scriptTag.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js'; // set the source of the script to your script
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}(document, 'script'));
document.addEventListener('DOMContentLoaded', function () {
if(document.querySelectorAll('.section-header__subheading').length == 0 && document.querySelectorAll('.new-read-more').length){
  document.querySelectorAll('.new-read-more')[0].remove();
}
});
}